module.exports = __webpack_public_path__ + "static/img/coe-4ton-grey.fab1164.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coe-4ton-grey.svg
// module id = wbJz
// module chunks = 74